module.exports = __webpack_public_path__ + "static/media/better.460855ef.jpg";